export default {
      id: "instagram-usage",
      viewBox: "0 0 25 25",
      url: "../../assets/" + "sprite.svg#instagram-usage",
      toString: function () {
        return this.url;
      }
    }